import { render, staticRenderFns } from "./proCheck.vue?vue&type=template&id=402112f8&scoped=true&"
import script from "./proCheck.vue?vue&type=script&lang=js&"
export * from "./proCheck.vue?vue&type=script&lang=js&"
import style0 from "./proCheck.vue?vue&type=style&index=0&id=402112f8&scoped=true&lang=css&"
import style1 from "./proCheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402112f8",
  null
  
)

export default component.exports